export function ModernSlaveryPolicy() {
    return (
        <div className="font-mono  mx-auto px-4 py-10 leading-relaxed text-sm">
            <h1 className="text-2xl font-bold mb-6">Modern Slavery Statement</h1>

            <h2 className="text-xl font-bold mt-8 mb-3">1. Introduction</h2>
            <p className="mb-3">
                This statement is made pursuant to Section 54(1) of the Modern Slavery Act 2015 and constitutes the modern slavery and human trafficking statement of Netstratum Technologies for the financial year ending 31 March 2025.
            </p>
            <p className="mb-4">
                Netstratum Technologies is committed to acting ethically and with integrity in all our business dealings and relationships. We recognise that modern slavery - encompassing forced labour, debt bondage, human trafficking, and other forms of exploitation - is a serious violation of fundamental human rights. We are committed to implementing and enforcing effective systems and controls to ensure that modern slavery is not taking place anywhere within our own business or our supply chains.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">2. About Netstratum Technologies</h2>

            <h3 className="text-lg font-bold mt-6 mb-2">2.1 Our Business</h3>
            <p className="mb-3">
                Netstratum is a global technology solutions provider specializing in custom software development and enterprise IT services. With a strong focus on innovation and client-centricity, we empower businesses across industries to transform their digital infrastructure and drive measurable results.
            </p>
            <p className="mb-4">
                Across ten strategic global locations, Netstratum combines local insight with global expertise. Our seasoned team of engineers, consultants, and strategists ensures every solution is purpose-built- leveraging current and emerging technologies to meet your unique operational and business goals.
            </p>

            <ul className="list-disc pl-6 mb-4 space-y-3">
                <li>
                    <span className="font-bold">Blue Mesh</span> - A go-to platform for businesses to create automated workflows with an intuitive drag-and-drop interface and easy-to-follow instructions.
                    <p className="mt-2">
                        With its flexible and dynamic architecture, Bluemesh Studio evolves with the latest AI and machine learning advancements, helping organizations streamline, optimize, and automate business processes effortlessly.
                    </p>
                </li>

                <li>
                    <span className="font-bold">NCS (Netstratum Communication Suite)</span> - Netstratum Communication Suite (NCS) is a multitenant UCaaS platform designed for telecom providers, enterprises, and government organizations to modernize their communication infrastructure through modular services, advanced SDKs and APIs, complete white labeling, and integrated capabilities such as business phone, contact center, softphone, meetings, unified chat, and broadcast solutions.
                </li>

                <li>
                    <span className="font-bold">Professional Services</span> - technology consulting, implementation, build-to-spec solutions and support services for government and enterprise clients.
                </li>
            </ul>

            <h3 className="text-lg font-bold mt-6 mb-2">2.2 Our Supply Chains</h3>
            <p className="mb-2">Our supply chain primarily consists of the following categories -</p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Technology and software suppliers - cloud infrastructure providers, software licensing vendors, and development tools suppliers.</li>
                <li>Hardware suppliers - computing equipment, networking devices, and office equipment providers.</li>
                <li>Professional services suppliers - subcontractors, consultants, and specialist service providers who support our project delivery.</li>
                <li>Facilities and operations suppliers - office services, facilities management, and administrative service providers.</li>
            </ul>
            <p className="mb-4">
                As a technology-focused company with a primarily skilled and professional workforce, our overall exposure to modern slavery risk is assessed as relatively low. Nevertheless, we take our obligations seriously and apply rigorous oversight across all supply chain relationships.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">3. Our Policies</h2>
            <p className="mb-4">
                Netstratum Technologies has implemented the following policies to prevent and address modern slavery and human trafficking across our operations
            </p>

            <h3 className="text-lg font-bold mt-6 mb-2">Anti-Slavery and Human Trafficking Policy</h3>
            <p className="mb-3">
                This policy sets out our commitment to acting ethically and with integrity, and establishes the minimum standards required of all employees, contractors, and suppliers in relation to modern slavery.
            </p>

            <h3 className="text-lg font-bold mt-6 mb-2">Supplier Code of Conduct</h3>
            <p className="mb-3">
                All suppliers are required to comply with our Supplier Code of Conduct, which includes explicit requirements relating to labour standards, ethical business practices, and compliance with all applicable laws, including the Modern Slavery Act 2015. Suppliers are required to cascade these requirements throughout their own supply chains.
            </p>

            <h3 className="text-lg font-bold mt-6 mb-2">Whistleblowing Policy</h3>
            <p className="mb-3">
                We maintain a confidential reporting mechanism that enables employees and external parties to raise concerns about unethical conduct - including any suspicions of modern slavery - without fear of retaliation. Details of how to report a concern are provided separately on our website.
            </p>

            <h3 className="text-lg font-bold mt-6 mb-2">Recruitment and Employment Policy</h3>
            <p className="mb-3">
                We conduct robust pre-employment checks on all directly employed staff, including verification of identity and right to work. We ensure that our employment terms, conditions, and practices meet or exceed applicable legal requirements, and we do not engage in any practices that could give rise to exploitation or forced labour.
            </p>

            <h3 className="text-lg font-bold mt-6 mb-2">Procurement Policy</h3>
            <p className="mb-4">
                Our procurement procedures include due diligence processes that assess suppliers' commitment to ethical labour practices and compliance with modern slavery legislation before and during the course of engagement.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">4. Due Diligence</h2>

            <h3 className="text-lg font-bold mt-6 mb-2">4.1 Supplier Due Diligence</h3>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Pre-qualification assessments for new suppliers that include specific questions relating to modern slavery compliance and ethical labour practices.</li>
                <li>Contractual requirements obligating suppliers to comply with the Modern Slavery Act 2015 and to cascade those requirements to their own supply chains.</li>
                <li>Periodic review of key supplier relationships to assess ongoing compliance with our standards and expectations.</li>
            </ul>

            <h3 className="text-lg font-bold mt-6 mb-2">4.2 Internal Due Diligence</h3>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Verification of employee identity and right-to-work documentation for all directly employed staff.</li>
                <li>Regular review of employment practices to ensure compliance with employment legislation and ethical standards.</li>
                <li>Monitoring of agency workers and contractors to ensure compliance with relevant regulations.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-3">5. Risk Assessment</h2>

            <h3 className="text-lg font-bold mt-6 mb-2">5.1 Identified Risk Areas</h3>
            <table className="w-full border border-gray-300 border-collapse mb-6 text-sm">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="border border-gray-300 p-2 text-left font-semibold">Risk Area</th>
                        <th className="border border-gray-300 p-2 text-left font-semibold">Risk Level</th>
                        <th className="border border-gray-300 p-2 text-left font-semibold">Mitigation Measures</th>
                    </tr>
                </thead>
                <tbody className="[&_tr:nth-child(even)]:bg-gray-50">
                    <tr>
                        <td className="border border-gray-300 p-2">International Operations</td>
                        <td className="border border-gray-300 p-2">Low to Medium</td>
                        <td className="border border-gray-300 p-2">
                            Enhanced due diligence for overseas suppliers and partners
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 p-2">Third-Party Contractors</td>
                        <td className="border border-gray-300 p-2">Low</td>
                        <td className="border border-gray-300 p-2">
                            Contractual obligations and right-to-work verification checks
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 p-2">Hardware Supply Chain</td>
                        <td className="border border-gray-300 p-2">Low to Medium</td>
                        <td className="border border-gray-300 p-2">
                            Preferential use of reputable suppliers with published modern slavery statements
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 p-2">Facilities Services</td>
                        <td className="border border-gray-300 p-2">Low</td>
                        <td className="border border-gray-300 p-2">
                            Supplier assessments and contractual requirements
                        </td>
                    </tr>
                </tbody>
            </table>

            <h3 className="text-lg font-bold mt-6 mb-2">5.2 Steps Taken to Manage Risk</h3>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>We require all significant suppliers to confirm compliance with modern slavery legislation.</li>
                <li>We prioritise ethical and transparent suppliers.</li>
                <li>We conduct enhanced due diligence for international operations.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-3">6. Training and Awareness</h2>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Induction Training for all new employees.</li>
                <li>Annual refresher training on modern slavery awareness.</li>
                <li>Specialist training for procurement, HR, and management roles.</li>
                <li>Supplier awareness initiatives.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-3">7. Looking Ahead</h2>
            <ul className="list-disc pl-6 space-y-1">
                <li>Enhance supplier assessments.</li>
                <li>Expand training programs.</li>
                <li>Conduct supply chain reviews.</li>
                <li>Engage with industry initiatives.</li>
            </ul>
        </div>
    )
}